module.exports = __webpack_public_path__ + "static/media/009.df3c4618.jpg";